import { DecodeError } from "./DecodeError.js";
function decode(codec, input) {
  const parsed = codec.safeParse(input);
  if (parsed.success) {
    return { value: parsed.data };
  }
  return {
    error: new DecodeError({ input, errors: parsed.error.issues })
  };
}
export {
  decode
};
//# sourceMappingURL=decode.js.map
